document.addEventListener('DOMContentLoaded', function () {
  const cb = document.getElementById('spoolingAddonCheckbox');
  if (!cb) return;

  const SERVICE_VARIANT_BY_PRICE = {
    20: 51019578769686,
    25: 51019578802454,
    30: 51019578835222,
    35: 51019578867990,
    40: 51019578900758,
  };

  const toNumber = (v) => {
    const n = Number(String(v || '').replace(/[^\d.]/g, ''));
    return Number.isFinite(n) ? n : 0;
  };

  const addItems = async (items) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) {
      const ct = res.headers.get('content-type') || '';
      const body = ct.includes('application/json') ? await res.json() : await res.text();
      throw new Error(typeof body === 'string' ? body : JSON.stringify(body));
    }
    return res.json();
  };

  // 找到“当前页面真正的加购按钮”
  const atcButtons = Array.from(document.querySelectorAll(
    'button#product-add-to-cart, button[name="add"][type="submit"], button[name="add"]'
  ));

  // 从按钮反推最近的 add-to-cart form（ELLA 常见）
  const findFormFromButton = (btn) =>
    btn.closest('form[action*="/cart/add"]') ||
    document.querySelector('form[action*="/cart/add"]');

  atcButtons.forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      if (!cb.checked) return; // 不选就不接管

      const form = findFormFromButton(btn);
      if (!form) return;

      e.preventDefault();
      e.stopPropagation();

      const reelVariantId = Number(form.querySelector('input[name="id"]')?.value);
      const qty = Number(form.querySelector('input[name="quantity"]')?.value || 1);

      const safeQty = Number.isFinite(qty) && qty > 0 ? qty : 1;

      const spoolingPrice = toNumber(cb.dataset.spoolingPrice || 0);
      const serviceVariantId = SERVICE_VARIANT_BY_PRICE[spoolingPrice];
      if (!serviceVariantId) return alert(`Spooling price $${spoolingPrice} not configured.`);

      const summary = cb.dataset.spoolingSummary || '';

      try {
        // 1) Add Reel (带 properties 让你左侧文案还原)
        await addItems([{
          id: reelVariantId,
          quantity: safeQty,
          properties: {
            'Add-On Spooling': 'Yes',
            'Spooling details': summary,
            'Spooling price': `$${spoolingPrice}`,
          },
        }]);

        // 2) Add Service (真实计价)
        await addItems([{
          id: serviceVariantId,
          quantity: safeQty,
          properties: {
            'Service Type': 'Spooling',
            'Linked Reel Variant ID': String(reelVariantId),
            'Spooling details': summary,
          },
        }]);

        window.location.href = '/cart';
      } catch (err) {
        console.error(err);
        alert('Spooling add failed:\n\n' + (err?.message || String(err)));
      }
    }, true);
  });
});
